// Small parser helpers for object-variable body parsing.
// Keeps the main parser entry focused on declaration extraction.

// Parse `var(--name)` shorthand used inside object variable values.
export function parseInlineObjectReference(segment: string): string | null {
  const trimmed = segment.trim()
  // Return null when segment does not start with `var(`.
  if (!trimmed.startsWith('var(')) {
    return null
  } else {
    // Continue var() token syntax validation.
  }

  // Matches inline object spread calls. Example match: "var(--layout)".
  const match = trimmed.match(/^var\(\s*(--[a-zA-Z_][\w-]*)\s*\)$/)
  // Return referenced object variable name when syntax is valid.
  if (match) {
    return match[1]
  } else {
    // Return null for invalid inline object reference tokens.
    return null
  }
}

// Detect reserved object keys that should never be assignable.
export function isReservedObjectKey(key: string): boolean {
  const normalized = key.trim().toLowerCase()
  // Return true for keys that can mutate object prototype behavior.
  return normalized === '__proto__'
    || normalized === 'prototype'
    || normalized === 'constructor'
}
